import React from 'react';
import type { FunctionComponent } from 'react';

// eslint-disable-next-line import/prefer-default-export
interface SectionHandlerProps {
    children: React.ReactNode;
}

export const SectionHandler: FunctionComponent<SectionHandlerProps> = ({ children }) => {
    return <>{children}</>;
};
